import config from '@/config';
import { Technician } from '@/models/Technician';
import { errorCodes, verticals } from '@puls/puls-common-constants';
import axios, { AxiosResponse } from 'axios';
const technicianUtils = {
	devicesByCategories: {
		[verticals.IDS.APPLIANCES]: {
			id: verticals.IDS.APPLIANCES,
			title: 'Appliances',
			devices: [266, 267, 268, 269, 270, 272, 273, 274, 275, 278, 281, 284, 290]
		},
		[verticals.IDS.HANDYMAN]: {
			id: verticals.IDS.HANDYMAN,
			title: 'Handyman',
			devices: [320, 321, 322, 334, 335, 336, 337, 338, 339, 340, 342]
		},
		[verticals.IDS.TV]: {
			id: verticals.IDS.TV,
			title: 'TV Installation',
			devices: [309, 310, 199, 200]
		},
		[verticals.IDS.PLUMBING]: {
			id: verticals.IDS.PLUMBING,
			title: 'Plumbing',
			devices: [299, 300, 301, 302, 305, 306, 308, 366, 367]
		},
		[verticals.IDS.HVAC]: {
			id: verticals.IDS.HVAC,
			title: 'HVAC',
			devices: [288, 289, 362, 363, 364, 377]
		}
	},
	getErrorFromCode: (errorCode: string | number) => {
		const errorsMap: {[key: number]: string} = {
			1: errorCodes.JOB_TAKEN_BY_OTHER_TECH,
			3: errorCodes.PHONE_ALREADY_EXIST,
			4: errorCodes.EMAIL_ALREADY_EXIST
		}
		if (typeof errorCode === 'number') return errorsMap[errorCode];
		return errorCode;
	},
	getAvailableCompanyTechnicians (params: any = { appointment_id: "n/a" }) : Promise<Technician[]> {
		return new Promise(async (resolve) => {
			try {
				const technicianResponse: AxiosResponse<any> = await axios.post(`${config.api}/portal/technician/company-technicians`, params);
				if (technicianResponse.data.data.technicians) {
					resolve(technicianResponse.data.data.technicians);
				} else {
					resolve([])
				}	
			} catch (error) {
				resolve([]);	
			}
		});
	}
}

export default technicianUtils;
